import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from './admin-layout.routing';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { MaterialDesignModule } from 'app/material-design/material-design.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AddStateComponent } from '../../manage-states/add-state/add-state.component';
import { ViewStatesComponent } from '../../manage-states/view-states/view-states.component';
import { AddDistrictsComponent } from '../../manage-district/add-districts/add-districts.component';
import { AddMunicipalityComponent } from '../../manage-municipality/add-municipality/add-municipality.component'
import { ComponentsModule } from 'app/components/components.module';
import { AdPlansComponent } from '../../ad-plans/ad-plans.component';
import { ViewDistrictsComponent } from '../../manage-district/view-districts/view-districts.component';
import { ViewMunicipalitiesComponent } from '../../manage-municipality/view-municipalities/view-municipalities.component';
import { ViewAdPlansComponent } from '../../manage-ad-plans/view-ad-plans/view-ad-plans.component';
import { ViewUsersComponent } from '../../manageusers/view-users/view-users.component';
import { AddBlogComponent } from '../../manage-blogs/add-blog/add-blog.component';
import { AddPropertyTypeComponent } from 'app/manage-property-types/add-property-type/add-property-type.component';
import { ViewPropertyTypeComponent } from 'app/manage-property-types/view-property-type/view-property-type.component';
import { QuillModule } from 'ngx-quill';
import { ViewBlogsComponent } from '../../manage-blogs/view-blogs/view-blogs.component';
import { EditBlogComponent } from '../../manage-blogs/edit-blog/edit-blog.component';
import { ManageRoadBlocksComponent } from '../../manage-road-blocks/manage-road-blocks.component';
import { EditRoadBlockComponent } from 'app/components/edit-road-block/edit-road-block.component';
import { ManageLocalAdsComponent } from '../../manage-local-ads/manage-local-ads.component';
import { EditLocalAdsComponent } from '../../components/edit-local-ads/edit-local-ads.component';
import { VerifyBankTransferComponent } from '../../verify-bank-transfer/verify-bank-transfer.component';
import { VerifyBankPaymentsComponent } from 'app/verify-bank-payments/verify-bank-payments.component';
import { ManageBannerImagesComponent } from '../../manage-banner-images/manage-banner-images.component';
import { EditBannerImageComponent } from '../../components/edit-banner-image/edit-banner-image.component';
import { ImagePreviewComponent } from 'app/components/image-preview/image-preview.component';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';
import { ManagePropertiesComponent } from '../../manage-properties/manage-properties.component';
import { EsewaComponent } from '../../esewa/esewa.component';
import { CashPaymentsComponent } from '../../cash-payments/cash-payments.component';
import { EditUserComponent } from '../../edit-user/edit-user.component';
import { ProfileComponent } from '../../profile/profile.component';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { EditPropertyComponent } from 'app/edit-property/edit-property.component';
import { EditLocationInfoComponent } from 'app/components/edit-location-info/edit-location-info.component';
import { EditPropertyFacilitiesComponent } from 'app/components/edit-property-facilities/edit-property-facilities.component';
import { EditPropertyImagesComponent } from 'app/components/edit-property-images/edit-property-images.component';
import { EditProperyTypeComponent } from 'app/components/edit-propery-type/edit-propery-type.component';
import { WindowRef } from 'app/Window/WindowRef';
import { BankPaymentComponent } from 'app/components/bank-payment/bank-payment.component';
import { BankTransferComponent } from 'app/components/bank-transfer/bank-transfer.component';
import { EditPropertyPaymentComponent } from 'app/components/edit-property-payment/edit-property-payment.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialDesignModule,
    ComponentsModule,
    NgxGalleryModule,
    AngularEditorModule,
    QuillModule.forRoot({
      modules: {
        syntax: false,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],
          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction
          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['clean'],                                         // remove formatting button
          ['link', 'image', 'video'],
        ]
      }
    }),
  ],
  declarations: [
    DashboardComponent,
    AddStateComponent,
    ViewStatesComponent,
    AddDistrictsComponent,
    AddMunicipalityComponent,
    ViewStatesComponent,
    AddDistrictsComponent,
    AdPlansComponent,
    ViewDistrictsComponent,
    ViewMunicipalitiesComponent,
    ViewAdPlansComponent,
    ViewUsersComponent,
    AddBlogComponent,
    AddPropertyTypeComponent,
    ViewPropertyTypeComponent,
    ViewBlogsComponent,
    EditBlogComponent,
    ManageRoadBlocksComponent,
    EditRoadBlockComponent,
    ManageLocalAdsComponent,
    EditLocalAdsComponent,
    VerifyBankTransferComponent,
    VerifyBankPaymentsComponent,
    ManageBannerImagesComponent,
    EditBannerImageComponent,
    ImagePreviewComponent,
    ConfirmationBoxComponent,
    ManagePropertiesComponent,
    EsewaComponent,
    CashPaymentsComponent,
    EditUserComponent,
    ProfileComponent,
    EditPropertyComponent,
    EditLocationInfoComponent,
    EditPropertyFacilitiesComponent,
    EditPropertyImagesComponent,
    EditProperyTypeComponent,
    BankPaymentComponent,
    BankTransferComponent,
    EditPropertyPaymentComponent
  ],
  entryComponents: [
    EditLocationInfoComponent,
    EditPropertyFacilitiesComponent,
    EditPropertyImagesComponent,
    EditProperyTypeComponent,
    ImagePreviewComponent,
    ConfirmationBoxComponent,
    EditRoadBlockComponent,
    EditLocalAdsComponent,
    EditBannerImageComponent,
    EditUserComponent,
    BankPaymentComponent,
    BankTransferComponent,
    EditPropertyPaymentComponent
  ],
  providers: [
    WindowRef
  ]
})

export class AdminLayoutModule {}
